import { render, staticRenderFns } from "./guidelinePage.vue?vue&type=template&id=2d6e23f1&scoped=true&"
import script from "./guidelinePage.vue?vue&type=script&lang=ts&"
export * from "./guidelinePage.vue?vue&type=script&lang=ts&"
import style0 from "./guidelinePage.vue?vue&type=style&index=0&id=2d6e23f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6e23f1",
  null
  
)

export default component.exports